import React, { useEffect, useRef } from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/Components/ui/table'
import { Checkbox } from '@/Components/ui/checkbox'
import { Form, FormControl, FormField, FormItem, FormLabel } from '@/Components/ui/form'
import { Input } from '@/Components/ui/input'
import { Textarea } from '@/Components/ui/textarea'
import SearchableDropdown from '@/Components/Common/SearchableDropdown'
import DatePicker from '@/Components/Common/DatePicker'
import DateTimePicker from '@/Components/Common/DateTimePicker'
import { Button } from '@/Components/ui/button'
import { format } from 'date-fns'
import Constant from '@/utils/Constant'
const Followupmail = ({ form, event, updateEvent, followupStatus }) => {
    useEffect(() => {
        console.log('workallocation.follow_up : ')
    }, [])
    return (
        <div>
            {console.log('first', event.work_allocation.follow_up)}
            <h4 className="m-4 text-gray-600 ">Follow-up Email Table</h4>
            <Table className="mt-4 mb-2 ">
                <TableHeader className="bg-purple-100">
                    <TableHead className="text-purple-950 font-semibold text-[12px] border border-gray-200 p-0 text-center">
                        <Checkbox
                            onClick={() => {
                                const allChecked = !event.work_allocation.follow_up.every((item) => item.checkbox)
                                updateEvent({
                                    work_allocation: {
                                        ...event.work_allocation,
                                        follow_up: event.work_allocation.follow_up.map((item) => ({
                                            ...item,
                                            checkbox: allChecked,
                                        })),
                                    },
                                })
                            }}
                            checked={event?.work_allocation?.follow_up?.length > 0 && event?.work_allocation?.follow_up?.every((row) => row.checkbox)}
                        />
                    </TableHead>
                    <TableHead className="text-purple-950 font-semibold text-[12px] border border-gray-200 p-0 text-center">Sr. No</TableHead>
                    <TableHead className="text-purple-950 font-semibold text-[12px] border border-gray-200 p-0 text-center">Type</TableHead>
                    <TableHead className="text-purple-950 font-semibold text-[12px] border border-gray-200 p-0 text-center">Status</TableHead>
                    <TableHead className="text-purple-950 font-semibold text-[12px] border border-gray-200 p-0 text-center">Date</TableHead>
                </TableHeader>
                <TableBody>
                    {event?.work_allocation?.follow_up?.length > 0 &&
                        event.work_allocation.follow_up.map((row, index) => (
                            <TableRow className="border border-gray-200 p-0 text-center" key={row.idx}>
                                <Checkbox
                                    className="mt-2 mx-2"
                                    checked={row.checkbox}
                                    onClick={() => {
                                        updateEvent({
                                            work_allocation: {
                                                ...event.follow_up,
                                                follow_up: event.work_allocation?.follow_up.map((item, index) => {
                                                    return item.idx === row.idx ? { ...item, checkbox: !item.checkbox } : item
                                                }),
                                            },
                                        })
                                    }}
                                />
                                <TableCell className="border border-gray-200 p-0 text-center">{index + 1}</TableCell>
                                <TableCell className="border border-gray-200 p-0 text-center">
                                    <FormField
                                        control={form.control}
                                        name="type"
                                        render={({ field }) => (
                                            <FormItem className="space-y-1">
                                                <FormControl>
                                                    <SearchableDropdown
                                                        options={[{ type: 'Query' }, { type: 'TIOC Query' }]}
                                                        className="outline-none ring-0 focus-visible:ring-0 border-none shadow-none w-full focus:shadow-none"
                                                        label="type"
                                                        selectedVal={row.type}
                                                        handleChange={(e) => {
                                                            const updatedList = event.work_allocation.follow_up?.map((icdRow) =>
                                                                icdRow.idx === row.idx ? { ...icdRow, type: e } : icdRow
                                                            )
                                                            updateEvent({
                                                                work_allocation: {
                                                                    ...event.work_allocation,
                                                                    follow_up: updatedList,
                                                                },
                                                                update_obj: {
                                                                    name: event?.work_allocation?.name,
                                                                    data: {
                                                                        followup_email_table: updatedList,
                                                                    },
                                                                },
                                                            })
                                                        }}
                                                    />
                                                </FormControl>
                                            </FormItem>
                                        )}
                                    />
                                </TableCell>
                                <TableCell className="border border-gray-200 p-0 text-center">
                                    <FormField
                                        control={form.control}
                                        name="email_status"
                                        render={({ field }) => (
                                            <FormItem className="space-y-1">
                                                <FormControl>
                                                    <SearchableDropdown
                                                        options={followupStatus}
                                                        className="outline-none ring-0 focus-visible:ring-0 border-none shadow-none w-full focus:shadow-none"
                                                        label="followup_status"
                                                        selectedVal={row.email_status}
                                                        handleChange={(e) => {
                                                            const updatedList = event.work_allocation.follow_up?.map((icdRow) =>
                                                                icdRow.idx === row.idx ? { ...icdRow, email_status: e } : icdRow
                                                            )
                                                            updateEvent({
                                                                work_allocation: {
                                                                    ...event.work_allocation,
                                                                    follow_up: updatedList,
                                                                },
                                                                update_obj: {
                                                                    name: event?.work_allocation?.name,
                                                                    data: {
                                                                        followup_email_table: updatedList,
                                                                    },
                                                                },
                                                            })
                                                        }}
                                                    />
                                                </FormControl>
                                            </FormItem>
                                        )}
                                    />
                                </TableCell>
                                <TableCell className="border border-gray-200 p-0 text-center">
                                    <FormField
                                        control={form.control}
                                        name={`date${row.idx}`}
                                        render={({ field }) => (
                                            <FormItem className="space-y-1">
                                                <FormControl>
                                                    <DateTimePicker
                                                        value={row.date ? row.date : ''}
                                                        handleChanges={(val) => {
                                                            const updatedList = event.work_allocation.follow_up?.map((icdRow) =>
                                                                icdRow.idx === row.idx ? { ...icdRow, date: val } : icdRow
                                                            )
                                                            updateEvent({
                                                                work_allocation: {
                                                                    ...event.work_allocation,
                                                                    follow_up: updatedList,
                                                                },
                                                                update_obj: {
                                                                    name: event.work_allocation.name,
                                                                    data: {
                                                                        followup_email_table: updatedList,
                                                                    },
                                                                },
                                                            })
                                                        }}
                                                        className="outline-none ring-0 focus-visible:ring-0 border border-none shadow-none w-full focus:shadow-none"
                                                    />
                                                </FormControl>
                                            </FormItem>
                                        )}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
            <Button
                type="button"
                className=" hover:bg-gray-200 bg-gray-200 border-gray-800 text-gray-600 text-[12px]"
                onClick={() => {
                    updateEvent({
                        work_allocation: {
                            ...event.work_allocation,
                            follow_up: [
                                ...event.work_allocation.follow_up,
                                {
                                    idx: parseInt(event.work_allocation.follow_up.length) + 1,
                                    checkbox: false,
                                    type: '',
                                    email_status: '',
                                    date: '',
                                },
                            ],
                        },
                    })
                }}
            >
                Add Row
            </Button>
            {console.log('in delete', event.work_allocation.follow_up)}
            {event.work_allocation.follow_up.some((row) => row.checkbox) && !event.work_allocation.follow_up.every((row) => row.checkbox) && (
                <Button
                    type="button"
                    className="bg-primary-red ml-1 font-normal"
                    onClick={() => {
                        updateEvent({
                            work_allocation: {
                                ...event.work_allocation,
                                follow_up: event.work_allocation.follow_up.filter((row) => !row.checkbox),
                            },
                            update_obj: {
                                name: event.work_allocation.name,
                                data: {
                                    followup_email_table: event.work_allocation.follow_up.filter((row) => !row.checkbox),
                                },
                            },
                        })
                    }}
                >
                    Delete
                </Button>
            )}

            {event.work_allocation.follow_up.length > 0 && event.work_allocation.follow_up.every((row) => row.checkbox) && (
                <Button
                    type="button"
                    className="bg-primary-red ml-1 font-normal"
                    onClick={() => {
                        updateEvent({
                            work_allocation: {
                                ...event.work_allocation,
                                follow_up: [],
                            },
                            update_obj: {
                                name: event.work_allocation.name,
                                data: {
                                    followup_email_table: [],
                                },
                            },
                        })
                    }}
                >
                    Delete All
                </Button>
            )}
        </div>
    )
}

export default Followupmail
